module.exports = __webpack_public_path__ + "img/review.d8c68234.png";